import { createSlice } from "@reduxjs/toolkit";
import { PagamentoLoteModel } from "../../../models/pagamentoLote/pagamentoLoteModel";
import { buscarPagamentoLote } from "../../../services/pagamentoLoteService";
import { resetAll } from "../../actions/actions";

export interface PagamentoLoteState {
  //buscar pagamento lote
  loading: boolean;
  list: PagamentoLoteModel[];
  //internal
  modalDeletar: boolean;
}

const initialState: PagamentoLoteState = {
  //buscar pagamento lote
  loading: false,
  list: [],
  //internal
  modalDeletar: false,
};

export const pagamentoLoteSlice = createSlice({
  name: "pagamentoLote",
  initialState,
  reducers: {
    //internal
    setModalDeletarPagamentoLote: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar pagamento lote
    builder.addCase(buscarPagamentoLote.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarPagamentoLote.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarPagamentoLote.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //internal
  setModalDeletarPagamentoLote,
} = pagamentoLoteSlice.actions;

export default pagamentoLoteSlice.reducer;
